import React, { useEffect, useState } from "react";

import {
  Row,
  Col,
  Table,
  Form,
  Button,
  Card,
  FormControl,
  InputGroup,
  Badge,
} from "react-bootstrap";

import ActionForm from "components/attendance/ActionForm";
import HRPagination from "components/HRPagination";
import { useGetAnalyticsQuery } from "state/slices/analytics/analyticsApiSlice";

const ITEMS_PER_PAGE = 6;

const AnalyticsViewManagement = ({
  isAllowedToUpdate = false,
  handleCheckboxChange = () => { },
  formikValues = {
    id: null,
    cl: "",
    totalDD: "",
  },
  handleChange = () => { },
  updateAnalytics = () => { },
  selectedRow = null,
}) => {
  const [currentData, setCurrentData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const currentDate = new Date();
  const analyticsMonth =
    currentDate.getMonth() !== 0 ? currentDate.getMonth() : 12;
  const analyticsYear =
    currentDate.getMonth() !== 0
      ? currentDate.getFullYear()
      : currentDate.getFullYear() - 1;

  const [selectedMonthYear, setSelectedMonthYear] = useState({
    year: analyticsYear,
    month: analyticsMonth,
  });

  const {
    data: analyticsData,
    isFetching: isFetchingAnalytics,
    isError: isAnalyticsError,
    refetch: refetchAnalytics,
  } = useGetAnalyticsQuery(selectedMonthYear);

  useEffect(() => {
    refetchAnalytics();
  }, [selectedMonthYear]);

  useEffect(() => {
    if (analyticsData && !isAnalyticsError) {
      const filteredData = analyticsData
        ? analyticsData.filter((item) =>
            Object.values(item).some(
              (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(searchTerm.toLowerCase())
            )
          )
        : [];

      setTotalPages(Math.ceil(filteredData.length / ITEMS_PER_PAGE));
      const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
      const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
      setCurrentData(filteredData.slice(indexOfFirstItem, indexOfLastItem));
    } else {
      setCurrentData([]);
      setTotalPages(1);
    }
  }, [analyticsData, isAnalyticsError, searchTerm, currentPage, selectedRow]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleActionSubmit = async (values) => {
    setSelectedMonthYear({
      year: parseInt(values.year, 10),
      month: parseInt(values.month, 10),
    });
  };

  return (
    <>
      <Card className="py-3">
        <Card.Body>
          <div className="d-md-flex justify-content-between align-items-center">
            <ActionForm
              onSubmit={handleActionSubmit}
              attendanceYear={analyticsYear}
              attendanceMonth={analyticsMonth}
            />
            <Row className="flex-row-reverse flex-md-row mb-3">
              <Col xs={12}>
                <InputGroup>
                  <FormControl
                    type="text"
                    className="shadow-none border border-1"
                    placeholder="Search Here..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </InputGroup>
              </Col>
            </Row>
          </div>
          <Table striped bordered hover responsive className="text-center">
            <tbody>
              {currentData.length > 0 && !isFetchingAnalytics ? (
                <>
                  <tr>
                    <th></th>
                    {currentData.map((item, index) => (
                      <td key={index}>{item.name}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Lates</th>
                    {currentData.map((item, index) => (
                      <td key={index}>{item.late && item.late > 0 ? item.late : <span className="text-muted">0</span>}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>OT's</th>
                    {currentData.map((item, index) => (
                      <td key={index}>{item.ot && item.ot > 0 ? item.ot : <span className="text-muted">0</span>}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Absents</th>
                    {currentData.map((item, index) => (
                      <td key={index}>{item.absent && item.absent > 0 ? item.absent : <span className="text-muted">0</span>}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Half Day</th>
                    {currentData.map((item, index) => (
                      <td key={index}>{item.halfDay && item.halfDay > 0 ? item.halfDay : <span className="text-muted">0</span>}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>Short Leave</th>
                    {currentData.map((item, index) => (
                      <td key={index}>{item.shortLeave && item.shortLeave > 0 ? item.shortLeave : <span className="text-muted">0</span>}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>P. CL's</th>
                    {currentData.map((item, index) => {
                      let clValue = item.cl ? item.cl : 0;
                      if (selectedRow?.id === item.id) {
                        clValue = formikValues.cl;
                      }

                      return (
                        <td key={index}>
                          {selectedRow?.id === item.id ? (
                            <Form.Control
                              type="number"
                              name="cl"
                              value={clValue}
                              className="text-center bg-transparent border-0 shadow-none"
                              onChange={handleChange}
                            />
                          ) : (
                            item.cl && item.cl > 0 ? item.cl : <span className="text-muted">0</span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    <th>CL</th>
                    {currentData.map((item, index) => (
                      <td key={index}>{item?.usedCL ? <Badge bg="success" className="fw-medium">Yes</Badge> : <Badge bg="danger" className="fw-medium">No</Badge>}</td>
                    ))}
                  </tr>
                  <tr>
                    <th>DD</th>
                    {currentData.map((item, index) => {
                      let totalDDValue = item.totalDD ? item.totalDD : 0;
                      if (selectedRow?.id === item.id) {
                        totalDDValue = formikValues.totalDD;
                      }

                      return (
                        <td key={index}>
                          {selectedRow?.id === item.id ? (
                            <Form.Control
                              type="number"
                              name="totalDD"
                              value={totalDDValue}
                              className="text-center bg-transparent border-0 shadow-none"
                              onChange={handleChange}
                            />
                          ) : (
                            item.totalDD && item.totalDD > 0 ? item.totalDD : <span className="text-muted">0</span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                  {isAllowedToUpdate && (
                    <tr>
                      <th>Edit</th>
                      {currentData.map((item, index) => (
                        <td key={index}>
                          <Form.Check
                            type="checkbox"
                            name={`row_${index}`}
                            value={item.id}
                            checked={selectedRow?.id === item.id}
                            onChange={(e) => handleCheckboxChange(e, item)}
                          />
                        </td>
                      ))}
                    </tr>
                  )}
                </>
              ) : (
                <tr className="bg-light border text-center">
                  <td colSpan={8} className="text-muted">
                    {isFetchingAnalytics ? "Loading Data..." : "No Data Found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="d-flex justify-content-between align-items-center">
            {isAllowedToUpdate && (
              <Button
                variant="primary"
                type="submit"
                disabled={selectedRow.id ? false : true}
                onClick={() => updateAnalytics(refetchAnalytics)}
              >
                Update
              </Button>
            )}

            {currentData.length > 0 && !isFetchingAnalytics && (
              <HRPagination
                totalPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default AnalyticsViewManagement;
